import { Composer } from "vue-i18n";
import { useValidators } from "@/composables/useValidators";
import type { GeneratorFieldConfig } from "@/signup/DynamicGeneratorField.vue";

export function getGridFields(t: Composer["t"]) {
  const { required } = useValidators(t);

  const gridOwnerFields: GeneratorFieldConfig[] = [
    {
      title: "grid_owner_name",
      model: "grid_owner_name",
      type: "string",
      validation: [required],
    },
    {
      title: "grid_owner_corporate_id",
      model: "grid_owner_corporate_id",
      type: "string",
      validation: [required],
    },
  ];

  return {
    gridOwnerFields,
  };
}
